/**
 *
 * Asynchronously loads the component for InstallationInstructions
 *
 */

import { lazyLoad } from 'utils/loadable';

export const CelebrationsGotoSlack = lazyLoad(
  () => import('./index'),
  module => module.CelebrationsGotoSlack,
);
